import React from "react";
import Images from "../../Component/Simage";
function HowItWorks() {
  return (
    <div className="depin_howIt_works">
      <div className="row">
        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3 mb-sm-3 mb-md-0">
          <div className="left_sec">
            <img src={Images.depintxt} className="img-fluid depin_src" />
            <h1 className="title-txt fw-700 mb-0">How It Works</h1>
            <p className="des-txt fw-500 mb-0">
              Thousands of people around the world just like you contribute
              their spare computing power to store and deliver media to dApps
              running on the AInfra Network. In return, they are rewarded with
              AIF tokens.
            </p>
          </div>
        </div>
        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <div className="ryt_sec">
            <div className="points">
              <img src={Images.hiw1} className="img-fluid img-src" />
              <p className="txt mb-0 fw-500">
                Earn rewards in AInfra for every data packet
              </p>
            </div>
            <div className="points">
              <img src={Images.hiw2} className="img-fluid img-src" />
              <p className="txt mb-0 fw-500">
                100% secure with super safety encryption
              </p>
            </div>
            <div className="points">
              <img src={Images.hiw3} className="img-fluid img-src" />
              <p className="txt mb-0 fw-500">
                Minimal Requirements and Simple Installation
              </p>
            </div>
            <div className="points">
              <img src={Images.hiw4} className="img-fluid img-src" />
              <p className="txt mb-0 fw-500">
                Only use what your device can spare
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HowItWorks;
